// Sports module - centralizes all sport-specific configurations
import { PADEL_FLOW } from './padel/padel.flow';
// TODO: Uncomment when ready to implement tennis and squash wizards
// import { TENNIS_FLOW } from './tennis/tennis.flow';
// import { SQUASH_FLOW } from './squash/squash.flow';
import type { WizardFlowConfig } from '../engine/types';
import { STEP_KEYS } from '../registry/stepKeys';

// Re-export shared components and schemas
export * from './shared';

// Re-export sport-specific modules
export * from './padel';
// TODO: Uncomment when ready to implement tennis and squash wizards
// export * from './tennis';
// export * from './squash';

// ============================================================================
// SPORT SELECTION FLOW (Initial step before sport is selected)
// ============================================================================

export const SPORT_SELECTION_FLOW: WizardFlowConfig = {
  id: 'sport-selection',
  sportId: null,
  name: 'Selección de Deporte',
  steps: [
    {
      id: 'sport',
      title: 'Deporte',
      description: 'Selecciona el deporte para tu torneo',
      componentKey: STEP_KEYS.SHARED_SPORT,
      draftSliceKey: 'sport',
    },
  ],
};

// ============================================================================
// FLOW REGISTRY
// ============================================================================

/**
 * All available flows (including sport selection)
 * TODO: Add tennis and squash flows when ready
 */
export const SPORT_FLOWS: Record<string, WizardFlowConfig> = {
  'sport-selection': SPORT_SELECTION_FLOW,
  'padel-default': PADEL_FLOW,
  // 'tennis-default': TENNIS_FLOW,
  // 'squash-default': SQUASH_FLOW,
};

/**
 * Sport ID to Flow ID mapping
 * TODO: Add tennis and squash when ready
 */
export const SPORT_TO_FLOW: Record<string, string> = {
  PADEL: 'padel-default',
  // TENNIS: 'tennis-default',
  // SQUASH: 'squash-default',
};

/**
 * Get flow configuration by flow ID
 */
export function getFlowById(flowId: string): WizardFlowConfig {
  const flow = SPORT_FLOWS[flowId];
  if (!flow) {
    throw new Error(`Flow not found: ${flowId}`);
  }
  return flow;
}

/**
 * Get flow configuration by flow ID (safe version)
 */
export function getFlowByIdSafe(flowId: string): WizardFlowConfig | undefined {
  return SPORT_FLOWS[flowId];
}

/**
 * Get flow configuration for a sport
 * Returns SPORT_SELECTION_FLOW if sportId is null or undefined
 */
export function getFlowForSport(
  sportId: string | null | undefined,
): WizardFlowConfig {
  if (!sportId) {
    return SPORT_SELECTION_FLOW;
  }
  const flowId = SPORT_TO_FLOW[sportId.toUpperCase()];
  return flowId ? SPORT_FLOWS[flowId] : SPORT_SELECTION_FLOW;
}

/**
 * Check if a sport has a registered flow
 */
export function hasSportFlow(sportId: string | null | undefined): boolean {
  if (!sportId) return false;
  return sportId.toUpperCase() in SPORT_TO_FLOW;
}

/**
 * Get all available flow IDs
 */
export function getAllFlowIds(): string[] {
  return Object.keys(SPORT_FLOWS);
}

/**
 * Get all supported sport IDs
 */
export function getSupportedSportIds(): string[] {
  return Object.keys(SPORT_TO_FLOW);
}
